import { create, useStore } from 'zustand';

import { useSignupModalStore, SignupModalStore } from './slice/signupModal';
import { usePricingModalStore, PricingModalStore } from './slice/pricingModal';
import { useStripeModalStore, StripeModalStore } from './slice/stripeModal';
import { useAiExpandStore, AiExpandStore } from './slice/aiExpand';

type AppStore = SignupModalStore &
  PricingModalStore &
  StripeModalStore &
  AiExpandStore;

const useRootStore = create<AppStore>((...a) => ({
  ...useSignupModalStore(...a),
  ...usePricingModalStore(...a),
  ...useStripeModalStore(...a),
  ...useAiExpandStore(...a),
}));

export const useSignupModal = <Tab>(
  selector?: (state: SignupModalStore) => Tab
) => useStore(useRootStore, selector!);

export const usePricingModal = <Tab>(
  selector?: (state: PricingModalStore) => Tab
) => useStore(useRootStore, selector!);

export const useStripeModal = <Tab>(
  selector?: (state: StripeModalStore) => Tab
) => useStore(useRootStore, selector!);

export const useAiExpand = <Tab>(selector?: (state: AiExpandStore) => Tab) =>
  useStore(useRootStore, selector!);

export default useRootStore;
